import { render, staticRenderFns } from "./FishingList.vue?vue&type=template&id=c550f364&scoped=true&"
import script from "./FishingList.vue?vue&type=script&lang=js&"
export * from "./FishingList.vue?vue&type=script&lang=js&"
import style0 from "./FishingList.vue?vue&type=style&index=0&id=c550f364&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c550f364",
  null
  
)

export default component.exports